export default "__VITE_ASSET__1033440b__"